import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';

import BaseFormContainer from '../../common/components/form/BaseFormContainer';

import { UserRoles } from '../user.constants';
import { getCurrentUser, getCurrentUserTeam } from '../user.selectors';

import * as userActions from '../user.actions';
import * as authActions from '../../auth/auth.actions';
import { EditProfileForm, EditProfileSimple } from './';
import { Localize } from '../../../locale/localization';

const constraints = {
  firstName: {
    presence: {
      message: `^${Localize('form.edit-profile.firstname.error')}`,
    }
  },
  lastName: {
    presence: {
      message: `^${Localize('form.edit-profile.lastname.error')}`,
    }
  },
  address: {
    presence: {
      message: `^${Localize('form.edit-profile.address.error')}`,
    }
  },
  zipcode: {
    length: {
      message: `^${Localize('form.edit-profile.zipcode.error')}`,
      is: 5,
    },
    numericality: {
      onlyInteger: true,
      message: `^${Localize('form.edit-profile.zipcode.error')}`,
    },
    presence: {
      message: `^${Localize('form.edit-profile.zipcode.error')}`,
    }
  },
  city: {
    presence: {
      message: `^${Localize('form.edit-profile.city.error')}`,
    }
  },
};

class EditProfileFormContainer extends BaseFormContainer {
  constructor(props) {
    super(props);

    const formData = {
      firstName: '',
      lastName: '',
      address: '',
      zipcode: '',
      city: '',
    };

    this.state = {
      ...this.state,
      formData,
    };
  }

  componentWillMount() {
    const { currentUser } = this.props;
    const {
      firstName = '',
      lastName = '',
      address = '',
      zipcode = '',
      city = '',
      _id,
    } = currentUser;

    const { formData } = this.state;

    this.setState({
      _id,
      formData: {
        ...formData,
        firstName,
        lastName,
        address,
        zipcode,
        city,
      }
    }, this.validate);
  }

  getConstraints = () => constraints;

  doSubmit = (formData) => {
    const { updateUser } = this.props;

    const {
      _id,
    } = this.state;

    updateUser({
      ...formData,
      _id
    }).then(() => {
      this.setState({
        isSubmitting: false,
      });
    });

    //TODO Success & error handling
  }

  render() {
    const { currentUser, currentUserTeam } = this.props;
    const shouldRenderForm = currentUser.role !== UserRoles.SUPERUSER;
    return (
      shouldRenderForm ? (
        <EditProfileForm
          enabled={!this.state.isSubmitting}
          onSubmit={this.onSubmit}
          onInputChange={this.onInputChange}
          onBlur={this.onBlur}
          errors={this.state.errors}
          touchedFields={this.state.touchedFields}
          isValid={this.state.isValid}
          email={currentUser.email}
          team={currentUserTeam ? currentUserTeam.name : null}
          firstName={this.state.formData.firstName}
          lastName={this.state.formData.lastName}
          address={this.state.formData.address}
          zipcode={this.state.formData.zipcode}
          city={this.state.formData.city}
        />
      ) : (
        <EditProfileSimple email={currentUser.email} />
      )
    );
  }
}

const mapStateToProps = (state) => {
  const currentUser = getCurrentUser(state);
  const currentUserTeam = getCurrentUserTeam(state);

  return {
    currentUser,
    currentUserTeam,
  };
};

const ConnectedEditProfileFormContainer = connect(
  mapStateToProps,
  Object.assign({}, userActions, authActions),
)(EditProfileFormContainer);

export default withRouter(ConnectedEditProfileFormContainer);


// WEBPACK FOOTER //
// ./src/modules/user/components/EditProfileFormContainer.js